import { Inject, Injectable } from '@angular/core';
import { $log } from '../ajs-upgraded-providers';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { IClientVersionInfoService } from '../config/typings/services';

@Injectable({
    providedIn: 'root'
})
export class ClientVersionInfoService implements IClientVersionInfoService {
    public static $name: string = 'clientVersionInfoService';

    constructor(
        @Inject($log) private $log: angular.ILogService,
        private appSettingsService: AppSettingsService
    ) {
    }

    public log() {
        let clientInfo = this.getClientVersionInfo();

        if (!clientInfo) {
            return;
        }

        this.$log.info(`
            CASLink
            Environment: ${clientInfo.environment}
            Machine: ${clientInfo.machine}
            Version: ${clientInfo.version}
        `);
    }

    private getClientVersionInfo() {
        let metadata = this.appSettingsService.getMetadata();

        return metadata.clientVersionInfo;
    }
}
